import React, { useEffect, useRef } from "react";
import "../Style/Ourblogs.css";

// Replace these with your actual image paths
import blog1Image from "../assets/Blog 1 (1).png";
import blog2Image from "../assets/Blog 1 (2).png";
import blog3Image from "../assets/Blog 1 (3).png";

const blogPosts = [
  {
    category: "WEB DEVELOPMENT",
    title: "10 Essential Features Every Business Website Needs in 2026",
    date: "January 15, 2026",
    description:
      "Discover the must-have features every modern business website should include, from responsive design and lightning-fast performance to advanced security, SEO optimization, and conversion-focused user experience.",
    image: blog1Image,
  },
  {
    category: "DIGITAL MARKETING",
    title: "Complete SEO Strategy to Increase Website Traffic Organically",
    date: "January 20, 2026",
    description:
      "Learn proven SEO techniques including keyword research, technical SEO, content optimization, local SEO, and link-building strategies that help businesses improve Google rankings and generate qualified leads.",
    image: blog2Image,
  },
  {
    category: "SOFTWARE DEVELOPMENT",
    title: "How Custom Software Solutions Improve Business Productivity",
    date: "January 28, 2026",
    description:
      "Explore how custom software automates operations, reduces costs, improves collaboration, and helps businesses scale efficiently with technology tailored to their unique workflows.",
    image: blog3Image,
  },
];

const Blog = () => {
  const sectionRef = useRef(null);

  const headerRef = useRef(null);

  useEffect(() => {
    const cards = sectionRef.current.querySelectorAll(".blog-card");

    const cardObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("blog-card--visible");
            cardObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    cards.forEach((card) => cardObserver.observe(card));

    const headerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("blog-section__header--visible");
            sectionRef.current.classList.add("blog-section--in-view");
            headerObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (headerRef.current) headerObserver.observe(headerRef.current);

    return () => {
      cardObserver.disconnect();
      headerObserver.disconnect();
    };
  }, []);

  return (
    <section className="blog-section" ref={sectionRef}>
      <span className="blog-section__bg-text" aria-hidden="true">
        OUR BLOGS
      </span>

      <div className="blog-section__container">
        <div className="blog-section__header" ref={headerRef}>
          <h2 className="blog-section__title">
            Latest Insights on Web Development, AI, Digital Marketing &amp;
            Technology
          </h2>
          <p className="blog-section__subtitle">
            Stay updated with expert articles, industry trends, practical
            guides, and technology insights from the MPeoples team. Learn how
            modern businesses use websites, mobile apps, AI, SEO, and digital
            transformation to achieve sustainable growth.
          </p>
        </div>

        <div className="blog-section__grid">
          {blogPosts.map((post, index) => (
            <article
              className="blog-card"
              key={post.title}
              style={{ transitionDelay: `${index * 120}ms` }}
            >
              <div className="blog-card__image-wrap">
                <img
                  src={post.image}
                  alt={post.title}
                  className="blog-card__image"
                  loading="lazy"
                />
                <span className="blog-card__category">{post.category}</span>
              </div>

              <div className="blog-card__body">
                <span className="blog-card__date">{post.date}</span>
                <h3 className="blog-card__title">{post.title}</h3>
                <p className="blog-card__description">{post.description}</p>

                {/*  */}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;